import script from "./CardUsuarioReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./CardUsuarioReserva.vue?vue&type=script&setup=true&lang=js"

import "./CardUsuarioReserva.vue?vue&type=style&index=0&id=08e4f890&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e4f890"]])

export default __exports__